export default __webpack_public_path__ + "static/media/InsideEyes_07.6c02979f.png";